"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _buttonControl = _interopRequireDefault(require("../../preact-components/button-control"));

var LogoImageControls = function LogoImageControls(_ref) {
  var onClick = _ref.onClick,
      onRemove = _ref.onRemove,
      logoUrl = _ref.logoUrl;

  if (logoUrl === '') {
    return (0, _preact.h)("div", null, (0, _preact.h)(_buttonControl.default, {
      class: "btn btn-default btn-upload",
      title: "Upload image",
      onClick: onClick
    }));
  }

  return (0, _preact.h)("div", {
    className: "default-header_logo-container"
  }, (0, _preact.h)("div", {
    className: "default-header_logo-wrapper"
  }, (0, _preact.h)("img", {
    src: (0, _absoluteUrlRuntime.resolveUrl)(logoUrl)
  })), (0, _preact.h)("div", {
    className: "default-header_logo_buttons"
  }, (0, _preact.h)(_buttonControl.default, {
    class: "btn btn-default btn-edit",
    title: "Edit",
    onClick: onClick
  }), (0, _preact.h)(_buttonControl.default, {
    class: "btn btn-default btn-delete",
    title: "Remove",
    onClick: onRemove
  })));
};

var _default = LogoImageControls;
exports.default = _default;